var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSolidWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 31,
    viewBox: "0 0 36 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 0.1875C18.9707 0.1875 19.8663 0.700195 20.3584 1.54102L35.1241 26.6973C35.6231 27.5449 35.6231 28.5908 35.1377 29.4385C34.6524 30.2861 33.7432 30.8125 32.7657 30.8125H3.23442C2.25688 30.8125 1.3477 30.2861 0.862345 29.4385C0.376993 28.5908 0.383829 27.5381 0.876017 26.6973L15.6416 1.54102C16.1338 0.700195 17.0293 0.1875 18 0.1875ZM18 8.9375C17.0909 8.9375 16.3594 9.66895 16.3594 10.5781V18.2344C16.3594 19.1436 17.0909 19.875 18 19.875C18.9092 19.875 19.6407 19.1436 19.6407 18.2344V10.5781C19.6407 9.66895 18.9092 8.9375 18 8.9375ZM20.1875 24.25C20.1875 23.6698 19.9571 23.1134 19.5468 22.7032C19.1366 22.293 18.5802 22.0625 18 22.0625C17.4199 22.0625 16.8635 22.293 16.4532 22.7032C16.043 23.1134 15.8125 23.6698 15.8125 24.25C15.8125 24.8302 16.043 25.3866 16.4532 25.7968C16.8635 26.207 17.4199 26.4375 18 26.4375C18.5802 26.4375 19.1366 26.207 19.5468 25.7968C19.9571 25.3866 20.1875 24.8302 20.1875 24.25Z",
    fill: "#E43120"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolidWarning);
export default __webpack_public_path__ + "static/media/SolidWarning.e5414149.svg";
export { ForwardRef as ReactComponent };